var BXmakerJsConstructor = function () {
    this.isDebug = false;
    this.data = {}; //данные необходимые с состояние и тп
    this.windowResizeQueue = [];
};

BXmakerJsConstructor.prototype.init = function (bComposite) {
    var that = this;

    console.log('Composite is on: ' + bComposite);

    if ($.cookie('bxmaker_debug') == 'Y') {
        this.isDebug = true;
        this.log('Включен режим отладки');
    }

    that.data = window.BXmakerJsData;

    that.initFlags();
    that.initEvents();
    that.initMdbasePage();
    that.initHeadResize();

    $(window).on("resize", $.debounce(200, function () {
        that.windowResizeWatcher();
    }));


};

//прокрутка к верху страницы
BXmakerJsConstructor.prototype.scrollToTop = function () {
    var that = this;

    $('html, body').animate({
        scrollTop: 0
    }, 400);
};

BXmakerJsConstructor.prototype.log = function () {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('bxmaker: ');
    console.log.apply(console, args);
};

BXmakerJsConstructor.prototype.logError = function () {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('bxmaker: ');
    console.error.apply(console, args);
};

BXmakerJsConstructor.prototype.debug = function (isOn) {
    if (!!isOn) {
        $.cookie('bxmaker_debug', 'Y', {path: '/', expires: 365});
        this.isDebug = true;
    } else {
        $.cookie('bxmaker_debug', 'N', {path: '/', expires: -1});
        this.isDebug = false;
    }
};


BXmakerJsConstructor.prototype.setData = function (key, data) {
    var that = this;
    window.BXmakerJsData[key] = that.data[key] = data;
};

BXmakerJsConstructor.prototype.getData = function (key) {
    var that = this;
    return that.data[key];
};

// возвращает данные о состоянии - корзина, отложенные и тп
BXmakerJsConstructor.prototype.getState = function () {
    var that = this;
    return that.getData('state');
};


BXmakerJsConstructor.prototype.getJsonFromUrl = function (hashBased) {
    var query;
    if (hashBased) {
        var pos = location.href.indexOf("?");
        if (pos == -1) return [];
        query = location.href.substr(pos + 1);
    } else {
        query = location.search.substr(1);
    }
    var result = {};
    query.split("&").forEach(function (part) {
        if (!part) return;
        part = part.split("+").join(" "); // replace every + with space, regexp-free version
        var eq = part.indexOf("=");
        var key = eq > -1 ? part.substr(0, eq) : part;
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
        var from = key.indexOf("[");
        if (from == -1) result[decodeURIComponent(key)] = val;
        else {
            var to = key.indexOf("]", from);
            var index = decodeURIComponent(key.substring(from + 1, to));
            key = decodeURIComponent(key.substring(0, from));
            if (!result[key]) result[key] = [];
            if (!index) result[key].push(val);
            else result[key][index] = val;
        }
    });
    return result;
};

BXmakerJsConstructor.prototype.storageSet = function (key, value) {
    var that = this;
    try {
        if (value === null) {
            return window.localStorage.removeItem(key);
        } else {
            return window.localStorage.setItem(key, JSON.stringify({
                "data": value
            }));
        }
    } catch (e) {
        if (e == QUOTA_EXCEEDED_ERR) {
            that.logError('LocalStorage limit exceeded');
        } else {
            that.logError('localStorage:', e);
        }
        return false;
    }
};

BXmakerJsConstructor.prototype.storageGet = function (key) {
    var that = this;
    var time = (new Date()).getTime();
    try {
        var obj = JSON.parse(window.localStorage.getItem(key));
        if (!!obj) {
            return obj['data'];
        }
        return false;
    } catch (e) {
        that.logError('localStorage:', e);
        return false;
    }
};

BXmakerJsConstructor.prototype.getTimeFormted = function (seconds) {
    return this.addZero(Math.floor(seconds / 3600)) + ':' + this.addZero(Math.floor(seconds % 3600 / 60)) + ':' + this.addZero(seconds % 60);
};

BXmakerJsConstructor.prototype.addZero = function (source, digits_length) {
    var text = source + '';
    var digits_length = digits_length || 2;
    while (text.length < digits_length)
        text = '0' + text;
    return text;
};

/**
 * Обработка события ресайза окна
 */
BXmakerJsConstructor.prototype.windowResizeWatcher = function () {
    for (var i in this.windowResizeQueue) {
        this.windowResizeQueue[i].call(this); // текущий контекст
    }
};
/**
 * Добавлене в обработчика ресайза в очередь
 * @param func
 */
BXmakerJsConstructor.prototype.addToWindowResizeQueue = function (func) {
    this.windowResizeQueue.push(func);
};

/**
 * Удаление обработчика ресайза из очерели
 * @param func
 */
BXmakerJsConstructor.prototype.removeFromWindowResizeQueue = function (func) {
    for (var i in this.windowResizeQueue) {
        if (this.windowResizeQueue[i] == func) {
            delete (this.windowResizeQueue[i]);
        }
    }
};


// подсветка кода --------------------------------------------------
BXmakerJsConstructor.prototype.initHighLighter = function () {
    hljs.initHighlightingOnLoad();
};

/**
 * Простановка флагов
 */
BXmakerJsConstructor.prototype.initFlags = function () {
    var arClass = [];

    // проверим наличие панели
    if ($('#bx-panel').length) {
        arClass.push('has-panel');

        if (!$('#bx-panel').hasClass('bx-panel-folded')) {
            $('body').addClass('has-panel--wide');
        }
    }

    //доступно копироваание
    if (!!navigator.clipboard) {
        arClass.push('has-clipboard');
    }

    $('body').addClass(arClass.join(' '));
};

/**
 * Действия на события
 */
BXmakerJsConstructor.prototype.initEvents = function () {
    var that = this;
    var arClass = [];

    //раскртие и скрытие панели ------------------------------
    $('#bx-panel-hider').on("click", function () {
        $('body').removeClass('has-panel--wide');
    });

    $('#bx-panel-expander').on("click", function () {
        $('body').addClass('has-panel--wide');
    });

    //удаление названия если оно пустое----------
    if ($('.header__title').text().trim().length <= 0) {
        $('.header__title').remove();
    }

};


BXmakerJsConstructor.prototype.initMdbasePage = function () {
    var that = this;
    var box = $('.mdbase');
    var activeItemId = '';
    var menuBox = null;
    var detailBox = null;
    var hash = '';

    if (!box.length) return false;

    menuBox = box.find('.mdbase-menu');
    detailBox = box.find('.mdbase-detail');
    activeItemId = detailBox.attr('data-id');

    //активность элементов
    $(window).on("hashchange", function (e) {
        that.recalcActiveSectionLik();
        that.recalcActiveSectionHeader();
        that.hideMobileMenu();
    });

    $(document).on("click", '.header__menu', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = $(this);
        that.showMobileMenu();
    });

    $(document).on("click", '.mdbase__content', function () {
        that.hideMobileMenu();
    });

    //копирвоание ссылки
    detailBox.on("click", '.mdbase-detail__header-link', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = $(this);
        var copytext = document.createElement('input');
        var url = document.createElement('a');

        url.href = btn.get(0).href;
        url.search = '';

        copytext.value = decodeURI(url.href);
        document.body.appendChild(copytext);
        copytext.select();
        document.execCommand('copy');
        document.body.removeChild(copytext);
    });

    // активация пунктов меню ---------
    menuBox.find('a.mdbase-menu__link').each(function () {
        var activeItem = $(this);
        var activeItemParent = $(this);
        var htmlHeadlines = [];

        if (activeItem.attr('data-id') == activeItemId) {
            //отметим как активный
            activeItem.addClass('active');

            //у родителей отметим активность
            activeItemParent = activeItem;
            while (activeItemParent.closest('ul').parent().find(' > a').length) {
                activeItemParent.closest('ul').parent().find(' > a').addClass('current');
                activeItemParent = activeItemParent.closest('ul').parent().find(' > a');
            }

            // формируем подменю ------
            // decodeURI(hash);
            detailBox.find('h2 a, h3 a, h4 a').each(function () {
                var link = $(this);
                htmlHeadlines.push('<li><a href="' + link.attr("href") + '" class="mdbase-menu__section-link" >' + link.text() + '</a></li>');
            });

            if (htmlHeadlines.length) {
                $('<ul class="mdbase-menu__section">' + htmlHeadlines.join('') + '</ul>').insertAfter(activeItem);
                that.recalcActiveSectionLik();
            }
        }
    });

    //заголовки из документа помещаем в меню
    that.recalcActiveSectionHeader();

    //подсветка кода
    that.initHighLighter();

    // подсветка искомого текста на странице
    that.highlightMdBaseSearchText();


    // прокрутка меню ---
    $('.mdbase-menu').jScrollPane();

    that.addToWindowResizeQueue(function () {
        $('.mdbase-menu').jScrollPane({reinitialise: true});
    });

};

/**
 *  Подсветит текущий  пункт документации в меню по хэшу в адресной строке
 */
BXmakerJsConstructor.prototype.recalcActiveSectionLik = function () {
    var that = this;
    var menuBox = $('.mdbase-menu');
    var hash = location.hash;

    menuBox.find('a.mdbase-menu__section-link').removeClass('active').filter(function () {
        var link = $(this);
        return (link.attr('href') == hash || link.attr('href') == decodeURI(hash));
    }).addClass('active');

};


/**
 * Подсветка заголовка
 */
BXmakerJsConstructor.prototype.recalcActiveSectionHeader = function () {
    var that = this;
    var box = $('.mdbase');
    var detailBox = box.find('.mdbase-detail');
    var hash = location.hash;

    detailBox.find('h2 a, h3 a, h4 a').removeClass('activeLight').filter(function () {
        var link = $(this);
        return (link.attr('href') == hash || link.attr('href') == decodeURI(hash));
    }).addClass('activeLight');

};


BXmakerJsConstructor.prototype.highlightMdBaseSearchText = function () {
    var that = this;
    var box = $('.mdbase');
    var detailBox = box.find('.mdbase-detail');
    var url = that.getJsonFromUrl();
    var arWords = [];
    var arReplace = {};

    if (!detailBox.length) {
        return false;
    }

    if (!!url.search) {
        arWords = url.search.split(" ");
    }

    for (var i in arWords) {
        arReplace[arWords[i]] = '<span class="mdbase-search-highlight">' + arWords[i] + '</span>'
    }

    for (var i in arReplace) {
        detailBox.find('*').replaceText(new RegExp(i, 'g'), arReplace[i]);
    }

    // detailBox.find('h2 a, h3 a, h4 a').removeClass('activeLight').filter(function () {
    //     var link = $(this);
    //     return (link.attr('href') == hash || link.attr('href') == decodeURI(hash));
    // }).addClass('activeLight');

};


/**
 * Скрытие мобильного меню
 */
BXmakerJsConstructor.prototype.hideMobileMenu = function () {
    $('body').removeClass('mobile-menu--show');
};
/**
 * Показ мобильного меню
 */
BXmakerJsConstructor.prototype.showMobileMenu = function () {
    $('body').addClass('mobile-menu--show');
};

BXmakerJsConstructor.prototype.initHeadResize = function () {
    var header = $('header.header');
    var menu = header.find('> .header__menu');
    var logoLink= header.find(' .header-logo__link');
    var logoIndex = header.find(' .header-logo__index');
    var logoSeparator = header.find(' .header-logo__separator');
    var title = header.find('> .header__title');
    var search = header.find('> .search-line');


    // пересчитывает размеры --------
    function resizeHeader(){
        var hw = header.width();
        var aw = 40;
        // объекты в порядке важности
        var ar = [
            menu, search, logoLink, logoIndex, logoSeparator, title
        ];

        ar.forEach(function (item) {
            item.removeClass('hidden');
        });

        ar.forEach(function (item) {
            aw += item.outerWidth(true);

            if (aw > hw)
            {
                item.addClass('hidden');
            }
        });

    }

    this.addToWindowResizeQueue(resizeHeader);
    resizeHeader();
};




// старт ---------------------------------------------------------------
if (window.frameCacheVars !== undefined) {
    BX.addCustomEvent("onFrameDataReceived", function (json) {
        var BXmakerJs = window.BXmakerJs = new BXmakerJsConstructor();
        BXmakerJs.init(true);
    });
} else {
    BX.ready(function () {
        var BXmakerJs = window.BXmakerJs = new BXmakerJsConstructor();
        BXmakerJs.init(false);
    });
}

// $(document).ready(function () {
//     var BXmakerJs = window.BXmakerJs = new BXmakerJsConstructor();
//     BXmakerJs.init(true);
// });
//----------------------------------------------------------------------












